import { render, staticRenderFns } from "./DialogQuantidadeCotas.vue?vue&type=template&id=72447149&"
import script from "./DialogQuantidadeCotas.vue?vue&type=script&lang=js&"
export * from "./DialogQuantidadeCotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports